import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Skeleton is now styled via SCSS partial `_customise-skeleton.scss`
const CustomiseSkeleton = ({ product = null, onClose = () => {} }) => {
    const containerClasses = classNames('product-main h-product skeleton-mode');
    const productTitle = product?.title ? product.title.split('-')[0] : '';
    return (
        <div className={containerClasses}>
            <button
                type="button"
                className="pagetitle-back pagetitle-back-category customise-skeleton__back"
                onClick={onClose}
            >
                Back
            </button>
            <div className="product-details customise-skeleton">
                <h2 className="product-main-title customise-skeleton__title">{productTitle}</h2>
                <div className="customise-skeleton__header-row">
                    <div className="skeleton-block skeleton-block--title" />
                    <div className="skeleton-block skeleton-block--subtitle" />
                </div>
                <div className="product-details-inner">
                    <div className="product-form">
                        <div className="customise-skeleton__media">
                            <div className="skeleton-block skeleton-block--media" />
                        </div>
                        <div className="options-container customise-skeleton__options">
                            <div className="skeleton-block skeleton-block--option" />
                            <div className="skeleton-block skeleton-block--option" />
                            <div className="skeleton-block skeleton-block--option" />
                        </div>
                        <div className="product-description-container customise-skeleton__description">
                            <div className="skeleton-block skeleton-block--text-line" />
                            <div className="skeleton-block skeleton-block--text-line" />
                            <div className="skeleton-block skeleton-block--text-line short" />
                        </div>
                        <div className="customise-skeleton__actions">
                            <div className="skeleton-block skeleton-block--action" />
                            <div className="skeleton-block skeleton-block--action small" />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

CustomiseSkeleton.propTypes = {
    product: PropTypes.object,
    onClose: PropTypes.func,
};

export default CustomiseSkeleton;
